<script lang="ts">
	import AlertBox from '$lib/components/atoms/alertBox/AlertBox.svelte';
	import RangeSlider from '$lib/components/atoms/range-slider/RangeSlider.svelte';
	import Icon from '$lib/components/icons/Icon.svelte';
	import * as m from '$paraglide/messages';
	import { createEventDispatcher } from 'svelte';

	const dispatch = createEventDispatcher<{ corridorRadiusChange: number }>();
</script>

<div
	class="flex flex-col bg-neutral-weakest b-2 b-solid border-michelin-blue rd-2 pt-4 pb-2 px-2 gap-8"
>
	<div class="flex items-center gap-1">
		<Icon icon="corridor" />
		<span class="text-md text-bold">{m.route_details__on_the_way_section__filters__detour()}</span>
	</div>
	<div class="flex flex-col gap-2">
		<RangeSlider
			min={5}
			max={20}
			defaultValue={[20]}
			getValueLabel={value =>
				m.route_details__on_the_way_section__filters__up_to({ value: value[0] })}
			label={m.route_details__on_the_way_section__filters__scope()}
			step={5}
			onValueChange={([radius]) => dispatch('corridorRadiusChange', radius)}
		/>
		<AlertBox
			color="neutral"
			icon="info"
			text={m.route_details__on_the_way_section__filters__infos()}
			class="text-coloredneutral"
		/>
	</div>
</div>
